function PageNotFound(props) {

  return (
    <div>404 Page Not Found</div>
  );

}

export default PageNotFound;